import { List, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import StaticServiceProviderFileGroupingModel from '../../../Common/Models/StaticServiceProviderFileGroupingModel';
import FileGroupingFileSpecLookup from '../Models/Lookups/FileGroupingFileSpecLookup';
import FileTypeLookup from '../Models/Lookups/FileTypeLookup';

@NeoModel
export default class ManageFileGroupingFileSpecComponentVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public generalApiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
        public fileGroupingFileSpecApiClient = AppService.get(Types.ApiClients.FileGroupingFileSpecApiClient),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {

        super(taskRunner);
    }
    
    public fileGroupingList = new List(StaticServiceProviderFileGroupingModel);
    public fileSpecList = new List(FileTypeLookup);
    public managedFileGroupingFileSpec = new FileGroupingFileSpecLookup();
    public isFieldReadOnlyInd: boolean = false;

    public async initialise() {
        await this.loadFileGroupings();
        await this.loadFileSpecs();
    }

    public async loadFileGroupings() {
        const response = await this.taskRunner.waitFor(this.generalApiClient.getStaticServiceProviderFileGroupingList());
        this.fileGroupingList.set(response.data);
    }

    public async loadFileSpecs() {
        const response = await this.taskRunner.waitFor(this.fileGroupingFileSpecApiClient.getFileSpecList());
        this.fileSpecList.set(response.data);
    }

    public async updateActiveStartEndDates() {
        const setFileSpecID = this.managedFileGroupingFileSpec.staticFileSpecId;

        this.managedFileGroupingFileSpec.activeStartDate = this.fileSpecList.find(i => i.staticFileSpecID === setFileSpecID)?.activeStartDate!;
        this.managedFileGroupingFileSpec.activeEndDate = this.fileSpecList.find(i => i.staticFileSpecID === setFileSpecID)?.activeEndDate!;
    }

}